
import { AccountService } from "@services/account.service";
import { IPlannedRouteDetail } from "@tms/_services/planned-route.service";
import * as angular from "angular";
import "./driverActivitySheet.scss";

class DriverActivitySheetComponentController implements angular.IComponentController {

    route: IPlannedRouteDetail;

    odoStart: number;
    odoEnd: number;

    logoUrl: string;

    static $inject = ["accountService"];

    constructor(
        private readonly accountService: AccountService) {
    }

    $onInit(): void {
        this.updateAccountImage();
    }

    // ---

    private updateAccountImage() {
        this.accountService.getAccountData()
            .then(account => {
                var image = account.Image;

                if(!image?.length){
                    return;
                }

                if (image.length > 30) {
                    this.logoUrl = image;
                }
            });
    }
}

export class DriverActivitySheetComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            route: "<?",
            odoStart: "<?",
            odoEnd: "<?"
        };

        this.controller = DriverActivitySheetComponentController;
        this.template = require("./driverActivitySheet.html");
    }
}
